// Mock data for demo mode

export const mockWorkspaces = [
  {
    bh_workspaceid: 'ws-1',
    bh_name: 'Engineering',
    bh_description: 'Engineering team workspace',
    createdon: '2024-01-15T10:00:00Z',
  },
  {
    bh_workspaceid: 'ws-2',
    bh_name: 'Product',
    bh_description: 'Product management workspace',
    createdon: '2024-01-10T08:00:00Z',
  },
];

export const mockProjects = [
  {
    bh_projectid: 'proj-1',
    bh_name: 'PM Plane Redux',
    bh_identifier: 'PMR',
    bh_description: 'Building a modern project management tool',
    bh_workspace: 'ws-1',
    createdon: '2024-01-16T10:00:00Z',
  },
  {
    bh_projectid: 'proj-2',
    bh_name: 'API Gateway',
    bh_identifier: 'API',
    bh_description: 'Central API Gateway service',
    bh_workspace: 'ws-1',
    createdon: '2024-01-17T10:00:00Z',
  },
  {
    bh_projectid: 'proj-3',
    bh_name: 'Mobile App',
    bh_identifier: 'MOB',
    bh_description: 'React Native mobile application',
    bh_workspace: 'ws-2',
    createdon: '2024-01-18T10:00:00Z',
  },
];

export const mockStates = [
  {
    bh_stateid: 'state-1',
    bh_name: 'Backlog',
    bh_color: '#6B7280',
    bh_group: 1,
    bh_sequence: 1,
    bh_project: 'proj-1',
  },
  {
    bh_stateid: 'state-2',
    bh_name: 'Todo',
    bh_color: '#F59E0B',
    bh_group: 2,
    bh_sequence: 2,
    bh_project: 'proj-1',
  },
  {
    bh_stateid: 'state-3',
    bh_name: 'In Progress',
    bh_color: '#3B82F6',
    bh_group: 3,
    bh_sequence: 3,
    bh_project: 'proj-1',
  },
  {
    bh_stateid: 'state-4',
    bh_name: 'Done',
    bh_color: '#10B981',
    bh_group: 4,
    bh_sequence: 4,
    bh_project: 'proj-1',
  },
];

// Helper to get date strings relative to today
const getDateStr = (daysFromToday: number) => {
  const date = new Date();
  date.setDate(date.getDate() + daysFromToday);
  return date.toISOString().split('T')[0];
};

export const mockWorkItems = [
  {
    bh_workitemid: 'wi-1',
    bh_name: 'Setup project structure',
    bh_description: 'Create initial project scaffolding with Vite and React',
    bh_sequenceid: 1,
    bh_priority: 4,
    bh_state: 'state-4',
    _bh_state_value: 'state-4',
    bh_project: 'proj-1',
    bh_startdate: getDateStr(-10),
    bh_targetdate: getDateStr(-5),
    bh_assignee: 'member-1',
    bh_cycle: 'cycle-1',
    bh_module: 'module-1',
    bh_parent: null,
    bh_estimate: 3,
    bh_epic: 'epic-1',
    createdon: '2024-01-16T11:00:00Z',
  },
  {
    bh_workitemid: 'wi-2',
    bh_name: 'Implement authentication',
    bh_description: 'Add Azure AD authentication using MSAL',
    bh_sequenceid: 2,
    bh_priority: 4,
    bh_state: 'state-3',
    _bh_state_value: 'state-3',
    bh_project: 'proj-1',
    bh_startdate: getDateStr(-5),
    bh_targetdate: getDateStr(2),
    bh_assignee: 'member-1',
    bh_cycle: 'cycle-2',
    bh_module: 'module-1',
    bh_parent: null,
    bh_estimate: 8,
    bh_epic: 'epic-1',
    createdon: '2024-01-16T12:00:00Z',
  },
  {
    bh_workitemid: 'wi-2a',
    bh_name: 'Setup MSAL configuration',
    bh_description: 'Configure MSAL library with Azure AD app registration',
    bh_sequenceid: 8,
    bh_priority: 4,
    bh_state: 'state-4',
    _bh_state_value: 'state-4',
    bh_project: 'proj-1',
    bh_startdate: getDateStr(-5),
    bh_targetdate: getDateStr(-3),
    bh_assignee: 'member-1',
    bh_cycle: 'cycle-2',
    bh_module: 'module-1',
    bh_parent: 'wi-2',
    bh_estimate: 2,
    bh_epic: 'epic-1',
    createdon: '2024-01-16T13:00:00Z',
  },
  {
    bh_workitemid: 'wi-2b',
    bh_name: 'Implement login flow',
    bh_description: 'Create login page and authentication flow',
    bh_sequenceid: 9,
    bh_priority: 4,
    bh_state: 'state-3',
    _bh_state_value: 'state-3',
    bh_project: 'proj-1',
    bh_startdate: getDateStr(-3),
    bh_targetdate: getDateStr(0),
    bh_assignee: 'member-1',
    bh_cycle: 'cycle-2',
    bh_module: 'module-1',
    bh_parent: 'wi-2',
    bh_estimate: 3,
    bh_epic: 'epic-1',
    createdon: '2024-01-16T14:00:00Z',
  },
  {
    bh_workitemid: 'wi-3',
    bh_name: 'Create Kanban board',
    bh_description: 'Build drag-and-drop Kanban board with dnd-kit',
    bh_sequenceid: 3,
    bh_priority: 3,
    bh_state: 'state-3',
    _bh_state_value: 'state-3',
    bh_project: 'proj-1',
    bh_startdate: getDateStr(-3),
    bh_targetdate: getDateStr(5),
    bh_assignee: 'member-2',
    bh_cycle: 'cycle-2',
    bh_module: 'module-2',
    bh_parent: null,
    bh_estimate: 5,
    bh_epic: 'epic-2',
    createdon: '2024-01-17T09:00:00Z',
  },
  {
    bh_workitemid: 'wi-4',
    bh_name: 'Add real-time updates',
    bh_description: 'Implement WebSocket connection for live updates',
    bh_sequenceid: 4,
    bh_priority: 3,
    bh_state: 'state-2',
    _bh_state_value: 'state-2',
    bh_project: 'proj-1',
    bh_startdate: getDateStr(3),
    bh_targetdate: getDateStr(10),
    bh_assignee: 'member-3',
    bh_cycle: 'cycle-2',
    bh_module: 'module-3',
    bh_parent: null,
    bh_estimate: 8,
    bh_epic: null,
    createdon: '2024-01-17T10:00:00Z',
  },
  {
    bh_workitemid: 'wi-5',
    bh_name: 'Design system components',
    bh_description: 'Build reusable UI components with Tailwind',
    bh_sequenceid: 5,
    bh_priority: 2,
    bh_state: 'state-1',
    _bh_state_value: 'state-1',
    bh_project: 'proj-1',
    bh_startdate: getDateStr(7),
    bh_targetdate: getDateStr(14),
    bh_assignee: 'member-2',
    bh_cycle: 'cycle-3',
    bh_module: 'module-2',
    bh_parent: null,
    bh_estimate: 5,
    bh_epic: 'epic-2',
    createdon: '2024-01-18T08:00:00Z',
  },
  {
    bh_workitemid: 'wi-6',
    bh_name: 'API documentation',
    bh_description: 'Document all API endpoints',
    bh_sequenceid: 6,
    bh_priority: 2,
    bh_state: 'state-1',
    _bh_state_value: 'state-1',
    bh_project: 'proj-1',
    bh_startdate: getDateStr(10),
    bh_targetdate: getDateStr(12),
    bh_assignee: null,
    bh_cycle: 'cycle-3',
    bh_module: null,
    bh_parent: null,
    bh_estimate: 2,
    bh_epic: null,
    createdon: '2024-01-18T09:00:00Z',
  },
  {
    bh_workitemid: 'wi-7',
    bh_name: 'Performance optimization',
    bh_description: 'Optimize bundle size and loading performance',
    bh_sequenceid: 7,
    bh_priority: 1,
    bh_state: 'state-1',
    _bh_state_value: 'state-1',
    bh_project: 'proj-1',
    bh_assignee: null,
    bh_cycle: null,
    bh_module: null,
    bh_parent: null,
    bh_estimate: null,
    bh_epic: null,
    createdon: '2024-01-18T10:00:00Z',
  },
];

export const mockLabels = [
  { bh_labelid: 'label-1', bh_name: 'Bug', bh_color: '#EF4444', bh_project: 'proj-1' },
  { bh_labelid: 'label-2', bh_name: 'Feature', bh_color: '#8B5CF6', bh_project: 'proj-1' },
  { bh_labelid: 'label-3', bh_name: 'Enhancement', bh_color: '#06B6D4', bh_project: 'proj-1' },
  { bh_labelid: 'label-4', bh_name: 'Documentation', bh_color: '#F59E0B', bh_project: 'proj-1' },
];

// Members/Users for assignees
export const mockMembers = [
  {
    bh_memberid: 'member-1',
    bh_name: 'Demo User',
    bh_email: 'demo@example.com',
    bh_avatar: null,
    bh_workspace: 'ws-1',
  },
  {
    bh_memberid: 'member-2',
    bh_name: 'John Smith',
    bh_email: 'john.smith@example.com',
    bh_avatar: null,
    bh_workspace: 'ws-1',
  },
  {
    bh_memberid: 'member-3',
    bh_name: 'Sarah Johnson',
    bh_email: 'sarah.j@example.com',
    bh_avatar: null,
    bh_workspace: 'ws-1',
  },
  {
    bh_memberid: 'member-4',
    bh_name: 'Mike Chen',
    bh_email: 'mike.chen@example.com',
    bh_avatar: null,
    bh_workspace: 'ws-1',
  },
];

// Cycles/Sprints
export const mockCycles = [
  {
    bh_cycleid: 'cycle-1',
    bh_name: 'Sprint 1',
    bh_description: 'Initial setup and authentication',
    bh_startdate: getDateStr(-14),
    bh_enddate: getDateStr(-1),
    bh_status: 'completed',
    bh_project: 'proj-1',
    createdon: '2024-01-10T10:00:00Z',
  },
  {
    bh_cycleid: 'cycle-2',
    bh_name: 'Sprint 2',
    bh_description: 'Core features implementation',
    bh_startdate: getDateStr(0),
    bh_enddate: getDateStr(13),
    bh_status: 'current',
    bh_project: 'proj-1',
    createdon: '2024-01-20T10:00:00Z',
  },
  {
    bh_cycleid: 'cycle-3',
    bh_name: 'Sprint 3',
    bh_description: 'Polish and testing',
    bh_startdate: getDateStr(14),
    bh_enddate: getDateStr(27),
    bh_status: 'upcoming',
    bh_project: 'proj-1',
    createdon: '2024-01-25T10:00:00Z',
  },
];

// Modules for feature grouping
export const mockModules = [
  {
    bh_moduleid: 'module-1',
    bh_name: 'Authentication',
    bh_description: 'User authentication and authorization',
    bh_status: 'in_progress',
    bh_lead: 'member-1',
    bh_project: 'proj-1',
    bh_startdate: getDateStr(-10),
    bh_targetdate: getDateStr(5),
    createdon: '2024-01-15T10:00:00Z',
  },
  {
    bh_moduleid: 'module-2',
    bh_name: 'UI Components',
    bh_description: 'Reusable design system components',
    bh_status: 'planned',
    bh_lead: 'member-2',
    bh_project: 'proj-1',
    bh_startdate: getDateStr(5),
    bh_targetdate: getDateStr(20),
    createdon: '2024-01-16T10:00:00Z',
  },
  {
    bh_moduleid: 'module-3',
    bh_name: 'Real-time Features',
    bh_description: 'WebSocket integration for live updates',
    bh_status: 'planned',
    bh_lead: 'member-3',
    bh_project: 'proj-1',
    bh_startdate: getDateStr(10),
    bh_targetdate: getDateStr(25),
    createdon: '2024-01-17T10:00:00Z',
  },
];

// Comments on work items
export const mockComments = [
  {
    bh_commentid: 'comment-1',
    bh_content: 'Started working on this. Will have a draft ready by EOD.',
    bh_workitem: 'wi-2',
    bh_author: 'member-1',
    createdon: '2024-01-17T14:30:00Z',
  },
  {
    bh_commentid: 'comment-2',
    bh_content: 'Looks good! Make sure to handle the token refresh flow.',
    bh_workitem: 'wi-2',
    bh_author: 'member-2',
    createdon: '2024-01-17T15:45:00Z',
  },
  {
    bh_commentid: 'comment-3',
    bh_content: 'This is blocked until authentication is complete.',
    bh_workitem: 'wi-3',
    bh_author: 'member-1',
    createdon: '2024-01-18T09:00:00Z',
  },
];

// File attachments
export const mockAttachments = [
  {
    bh_attachmentid: 'attach-1',
    bh_filename: 'auth-flow-diagram.png',
    bh_filesize: 245000,
    bh_mimetype: 'image/png',
    bh_url: 'https://example.com/files/auth-flow-diagram.png',
    bh_workitem: 'wi-2',
    bh_uploadedby: 'member-1',
    createdon: '2024-01-17T16:00:00Z',
  },
  {
    bh_attachmentid: 'attach-2',
    bh_filename: 'requirements.pdf',
    bh_filesize: 1200000,
    bh_mimetype: 'application/pdf',
    bh_url: 'https://example.com/files/requirements.pdf',
    bh_workitem: 'wi-1',
    bh_uploadedby: 'member-2',
    createdon: '2024-01-16T10:00:00Z',
  },
];

// Pages/Wiki
export const mockPages = [
  {
    bh_pageid: 'page-1',
    bh_name: 'Project Overview',
    bh_content: '# PM Plane Redux\n\nThis is the project overview page.\n\n## Goals\n\n- Build a modern project management tool\n- Support multiple workspaces and projects\n- Real-time collaboration\n\n## Stack\n\n- React + TypeScript\n- Tailwind CSS\n- Cloudflare Workers\n- Dataverse',
    bh_icon: '📋',
    bh_parent: null,
    bh_project: 'proj-1',
    bh_createdby: 'member-1',
    bh_archived: false,
    createdon: '2024-01-16T10:00:00Z',
    modifiedon: '2024-01-18T14:00:00Z',
  },
  {
    bh_pageid: 'page-2',
    bh_name: 'Technical Architecture',
    bh_content: '# Architecture\n\n## Frontend\n\nThe frontend is a React SPA using Vite for bundling.\n\n## Backend\n\nCloudflare Workers handles API requests.\n\n## Database\n\nDataverse stores all data.',
    bh_icon: '🏗️',
    bh_parent: 'page-1',
    bh_project: 'proj-1',
    bh_createdby: 'member-1',
    bh_archived: false,
    createdon: '2024-01-17T10:00:00Z',
    modifiedon: '2024-01-17T10:00:00Z',
  },
  {
    bh_pageid: 'page-3',
    bh_name: 'API Reference',
    bh_content: '# API Reference\n\n## Endpoints\n\n### GET /workspaces\n\nReturns all workspaces.\n\n### GET /projects/:workspaceId\n\nReturns projects for a workspace.',
    bh_icon: '📖',
    bh_parent: 'page-1',
    bh_project: 'proj-1',
    bh_createdby: 'member-2',
    bh_archived: false,
    createdon: '2024-01-18T10:00:00Z',
    modifiedon: '2024-01-18T10:00:00Z',
  },
];

// Saved Views
export const mockViews = [
  {
    bh_viewid: 'view-1',
    bh_name: 'My Issues',
    bh_filters: { assignee: 'member-1' },
    bh_display: { groupBy: 'state', sortBy: 'priority' },
    bh_project: 'proj-1',
    bh_createdby: 'member-1',
    createdon: '2024-01-17T10:00:00Z',
  },
  {
    bh_viewid: 'view-2',
    bh_name: 'High Priority',
    bh_filters: { priority: [3, 4] },
    bh_display: { groupBy: 'state', sortBy: 'created' },
    bh_project: 'proj-1',
    bh_createdby: 'member-1',
    createdon: '2024-01-18T10:00:00Z',
  },
  {
    bh_viewid: 'view-3',
    bh_name: 'Current Sprint',
    bh_filters: { cycle: 'cycle-2' },
    bh_display: { groupBy: 'assignee', sortBy: 'priority' },
    bh_project: 'proj-1',
    bh_createdby: 'member-2',
    createdon: '2024-01-18T11:00:00Z',
  },
];

// Activity Log
export const mockActivities = [
  {
    bh_activityid: 'act-1',
    bh_action: 'created',
    bh_field: null,
    bh_oldvalue: null,
    bh_newvalue: null,
    bh_workitem: 'wi-1',
    bh_actor: 'member-1',
    createdon: '2024-01-16T11:00:00Z',
  },
  {
    bh_activityid: 'act-2',
    bh_action: 'updated',
    bh_field: 'state',
    bh_oldvalue: 'state-2',
    bh_newvalue: 'state-3',
    bh_workitem: 'wi-1',
    bh_actor: 'member-1',
    createdon: '2024-01-17T09:00:00Z',
  },
  {
    bh_activityid: 'act-3',
    bh_action: 'updated',
    bh_field: 'state',
    bh_oldvalue: 'state-3',
    bh_newvalue: 'state-4',
    bh_workitem: 'wi-1',
    bh_actor: 'member-1',
    createdon: '2024-01-18T14:00:00Z',
  },
  {
    bh_activityid: 'act-4',
    bh_action: 'updated',
    bh_field: 'priority',
    bh_oldvalue: '3',
    bh_newvalue: '4',
    bh_workitem: 'wi-2',
    bh_actor: 'member-2',
    createdon: '2024-01-17T15:00:00Z',
  },
  {
    bh_activityid: 'act-5',
    bh_action: 'comment',
    bh_field: null,
    bh_oldvalue: null,
    bh_newvalue: 'comment-1',
    bh_workitem: 'wi-2',
    bh_actor: 'member-1',
    createdon: '2024-01-17T14:30:00Z',
  },
];

// Inbox/Notifications
export const mockNotifications = [
  {
    bh_notificationid: 'notif-1',
    bh_type: 'mention',
    bh_message: 'mentioned you in a comment',
    bh_workitem: 'wi-2',
    bh_actor: 'member-2',
    bh_recipient: 'member-1',
    bh_read: false,
    createdon: '2024-01-18T10:00:00Z',
  },
  {
    bh_notificationid: 'notif-2',
    bh_type: 'assigned',
    bh_message: 'assigned you to an issue',
    bh_workitem: 'wi-3',
    bh_actor: 'member-1',
    bh_recipient: 'member-2',
    bh_read: false,
    createdon: '2024-01-18T09:00:00Z',
  },
  {
    bh_notificationid: 'notif-3',
    bh_type: 'state_change',
    bh_message: 'moved to In Progress',
    bh_workitem: 'wi-2',
    bh_actor: 'member-1',
    bh_recipient: 'member-2',
    bh_read: true,
    createdon: '2024-01-17T16:00:00Z',
  },
];

// Epics for larger initiatives
export const mockEpics = [
  {
    bh_epicid: 'epic-1',
    bh_name: 'User Authentication System',
    bh_description: 'Complete authentication and authorization system',
    bh_color: '#8B5CF6',
    bh_status: 'in_progress',
    bh_project: 'proj-1',
    bh_lead: 'member-1',
    bh_startdate: getDateStr(-14),
    bh_targetdate: getDateStr(14),
    createdon: '2024-01-15T10:00:00Z',
  },
  {
    bh_epicid: 'epic-2',
    bh_name: 'Project Management Core',
    bh_description: 'Core project management features including boards, lists, and gantt',
    bh_color: '#3B82F6',
    bh_status: 'planned',
    bh_project: 'proj-1',
    bh_lead: 'member-2',
    bh_startdate: getDateStr(0),
    bh_targetdate: getDateStr(30),
    createdon: '2024-01-16T10:00:00Z',
  },
];

// Relation types: blocking, blocked_by, relates_to, duplicate_of
export const mockRelations = [
  {
    bh_relationid: 'rel-1',
    bh_issue: 'wi-2', // Implement authentication
    bh_related_issue: 'wi-1', // Setup project structure
    bh_relation_type: 'blocked_by',
    bh_project: 'proj-1',
  },
  {
    bh_relationid: 'rel-2',
    bh_issue: 'wi-3', // Create Kanban board
    bh_related_issue: 'wi-2', // Implement authentication
    bh_relation_type: 'blocked_by',
    bh_project: 'proj-1',
  },
  {
    bh_relationid: 'rel-3',
    bh_issue: 'wi-4', // Add real-time updates
    bh_related_issue: 'wi-3', // Create Kanban board
    bh_relation_type: 'relates_to',
    bh_project: 'proj-1',
  },
];

// Simple ID generator
let idCounter = 100;
const generateId = () => `id-${++idCounter}`;

// In-memory store for mutations
let workspaces = [...mockWorkspaces];
let projects = [...mockProjects];
let states = [...mockStates];
let workItems = [...mockWorkItems];
let labels = [...mockLabels];
let relations = [...mockRelations];
let members = [...mockMembers];
let cycles = [...mockCycles];
let modules = [...mockModules];
let comments = [...mockComments];
let attachments = [...mockAttachments];
let pages = [...mockPages];
let views = [...mockViews];
let activities = [...mockActivities];
let notifications = [...mockNotifications];
let epics = [...mockEpics];

// Mock API implementation
export const mockApi = {
  // Workspaces
  getWorkspaces: async () => {
    await delay(200);
    return workspaces;
  },
  getWorkspace: async (id: string) => {
    await delay(100);
    return workspaces.find(w => w.bh_workspaceid === id);
  },
  createWorkspace: async (data: any) => {
    await delay(300);
    const workspace = {
      bh_workspaceid: generateId(),
      bh_name: data.bh_name,
      bh_description: data.bh_description || '',
      createdon: new Date().toISOString(),
    };
    workspaces.push(workspace);
    return workspace;
  },
  updateWorkspace: async (id: string, data: any) => {
    await delay(200);
    const idx = workspaces.findIndex(w => w.bh_workspaceid === id);
    if (idx !== -1) {
      workspaces[idx] = { ...workspaces[idx], ...data };
      return workspaces[idx];
    }
    throw new Error('Workspace not found');
  },
  deleteWorkspace: async (id: string) => {
    await delay(200);
    workspaces = workspaces.filter(w => w.bh_workspaceid !== id);
  },

  // Projects
  getProjects: async (workspaceId: string) => {
    await delay(200);
    return projects.filter(p => p.bh_workspace === workspaceId);
  },
  getProject: async (id: string) => {
    await delay(100);
    return projects.find(p => p.bh_projectid === id);
  },
  createProject: async (data: any) => {
    await delay(300);
    const project = {
      bh_projectid: generateId(),
      bh_name: data.bh_name,
      bh_identifier: data.bh_identifier || 'PRJ',
      bh_description: data.bh_description || '',
      bh_workspace: data.bh_workspace,
      createdon: new Date().toISOString(),
    };
    projects.push(project);

    // Create default states for new project
    const defaultStates = [
      { bh_stateid: generateId(), bh_name: 'Backlog', bh_color: '#6B7280', bh_group: 1, bh_sequence: 1, bh_project: project.bh_projectid },
      { bh_stateid: generateId(), bh_name: 'Todo', bh_color: '#F59E0B', bh_group: 2, bh_sequence: 2, bh_project: project.bh_projectid },
      { bh_stateid: generateId(), bh_name: 'In Progress', bh_color: '#3B82F6', bh_group: 3, bh_sequence: 3, bh_project: project.bh_projectid },
      { bh_stateid: generateId(), bh_name: 'Done', bh_color: '#10B981', bh_group: 4, bh_sequence: 4, bh_project: project.bh_projectid },
    ];
    states.push(...defaultStates);

    return project;
  },
  updateProject: async (id: string, data: any) => {
    await delay(200);
    const idx = projects.findIndex(p => p.bh_projectid === id);
    if (idx !== -1) {
      projects[idx] = { ...projects[idx], ...data };
      return projects[idx];
    }
    throw new Error('Project not found');
  },
  deleteProject: async (id: string) => {
    await delay(200);
    projects = projects.filter(p => p.bh_projectid !== id);
  },

  // Work Items
  getWorkItems: async (projectId: string) => {
    await delay(200);
    return workItems.filter(wi => wi.bh_project === projectId);
  },
  getWorkItem: async (id: string) => {
    await delay(100);
    return workItems.find(wi => wi.bh_workitemid === id);
  },
  createWorkItem: async (data: any) => {
    await delay(300);
    const projectWorkItems = workItems.filter(wi => wi.bh_project === data.bh_project);
    const workItem = {
      bh_workitemid: generateId(),
      bh_name: data.bh_name,
      bh_description: data.bh_description || '',
      bh_sequenceid: projectWorkItems.length + 1,
      bh_priority: data.bh_priority || 1,
      bh_state: data.bh_state,
      _bh_state_value: data.bh_state,
      bh_project: data.bh_project,
      bh_assignee: data.bh_assignee || null,
      bh_cycle: data.bh_cycle || null,
      bh_module: data.bh_module || null,
      bh_parent: data.bh_parent || null,
      bh_estimate: data.bh_estimate || null,
      bh_epic: data.bh_epic || null,
      bh_startdate: data.bh_startdate || null,
      bh_targetdate: data.bh_targetdate || null,
      createdon: new Date().toISOString(),
    };
    workItems.push(workItem);
    // Log activity
    activities.push({
      bh_activityid: generateId(),
      bh_action: 'created',
      bh_field: null,
      bh_oldvalue: null,
      bh_newvalue: null,
      bh_workitem: workItem.bh_workitemid,
      bh_actor: 'member-1',
      createdon: new Date().toISOString(),
    });
    return workItem;
  },
  updateWorkItem: async (id: string, data: any) => {
    await delay(200);
    const idx = workItems.findIndex(wi => wi.bh_workitemid === id);
    if (idx !== -1) {
      workItems[idx] = {
        ...workItems[idx],
        ...data,
        _bh_state_value: data.bh_state || workItems[idx]._bh_state_value,
      };
      return workItems[idx];
    }
    throw new Error('Work item not found');
  },
  deleteWorkItem: async (id: string) => {
    await delay(200);
    workItems = workItems.filter(wi => wi.bh_workitemid !== id);
  },

  // States
  getStates: async (projectId: string) => {
    await delay(100);
    return states.filter(s => s.bh_project === projectId).sort((a, b) => a.bh_sequence - b.bh_sequence);
  },
  createState: async (data: any) => {
    await delay(300);
    const state = {
      bh_stateid: generateId(),
      ...data,
    };
    states.push(state);
    return state;
  },
  updateState: async (id: string, data: any) => {
    await delay(200);
    const idx = states.findIndex(s => s.bh_stateid === id);
    if (idx !== -1) {
      states[idx] = { ...states[idx], ...data };
      return states[idx];
    }
    throw new Error('State not found');
  },
  deleteState: async (id: string) => {
    await delay(200);
    states = states.filter(s => s.bh_stateid !== id);
  },

  // Labels
  getLabels: async (projectId: string) => {
    await delay(100);
    return labels.filter(l => l.bh_project === projectId);
  },
  createLabel: async (data: any) => {
    await delay(300);
    const label = {
      bh_labelid: generateId(),
      ...data,
    };
    labels.push(label);
    return label;
  },
  updateLabel: async (id: string, data: any) => {
    await delay(200);
    const idx = labels.findIndex(l => l.bh_labelid === id);
    if (idx !== -1) {
      labels[idx] = { ...labels[idx], ...data };
      return labels[idx];
    }
    throw new Error('Label not found');
  },
  deleteLabel: async (id: string) => {
    await delay(200);
    labels = labels.filter(l => l.bh_labelid !== id);
  },

  // Members
  getMembers: async (workspaceId: string) => {
    await delay(100);
    return members.filter(m => m.bh_workspace === workspaceId);
  },
  getMember: async (id: string) => {
    await delay(50);
    return members.find(m => m.bh_memberid === id);
  },

  // Cycles
  getCycles: async (projectId: string) => {
    await delay(100);
    return cycles.filter(c => c.bh_project === projectId);
  },
  getCycle: async (id: string) => {
    await delay(50);
    return cycles.find(c => c.bh_cycleid === id);
  },
  createCycle: async (data: any) => {
    await delay(200);
    const cycle = {
      bh_cycleid: generateId(),
      bh_name: data.bh_name,
      bh_description: data.bh_description || '',
      bh_startdate: data.bh_startdate,
      bh_enddate: data.bh_enddate,
      bh_status: data.bh_status || 'upcoming',
      bh_project: data.bh_project,
      createdon: new Date().toISOString(),
    };
    cycles.push(cycle);
    return cycle;
  },
  updateCycle: async (id: string, data: any) => {
    await delay(200);
    const idx = cycles.findIndex(c => c.bh_cycleid === id);
    if (idx !== -1) {
      cycles[idx] = { ...cycles[idx], ...data };
      return cycles[idx];
    }
    throw new Error('Cycle not found');
  },
  deleteCycle: async (id: string) => {
    await delay(200);
    // Remove cycle reference from work items
    workItems = workItems.map(wi =>
      wi.bh_cycle === id ? { ...wi, bh_cycle: null } : wi
    ) as typeof workItems;
    cycles = cycles.filter(c => c.bh_cycleid !== id);
  },

  // Modules
  getModules: async (projectId: string) => {
    await delay(100);
    return modules.filter(m => m.bh_project === projectId);
  },
  getModule: async (id: string) => {
    await delay(50);
    return modules.find(m => m.bh_moduleid === id);
  },
  createModule: async (data: any) => {
    await delay(200);
    const module = {
      bh_moduleid: generateId(),
      bh_name: data.bh_name,
      bh_description: data.bh_description || '',
      bh_status: data.bh_status || 'planned',
      bh_lead: data.bh_lead || null,
      bh_project: data.bh_project,
      bh_startdate: data.bh_startdate || null,
      bh_targetdate: data.bh_targetdate || null,
      createdon: new Date().toISOString(),
    };
    modules.push(module);
    return module;
  },
  updateModule: async (id: string, data: any) => {
    await delay(200);
    const idx = modules.findIndex(m => m.bh_moduleid === id);
    if (idx !== -1) {
      modules[idx] = { ...modules[idx], ...data };
      return modules[idx];
    }
    throw new Error('Module not found');
  },
  deleteModule: async (id: string) => {
    await delay(200);
    // Remove module reference from work items
    workItems = workItems.map(wi =>
      wi.bh_module === id ? { ...wi, bh_module: null } : wi
    ) as typeof workItems;
    modules = modules.filter(m => m.bh_moduleid !== id);
  },

  // Comments
  getComments: async (workItemId: string) => {
    await delay(100);
    return comments
      .filter(c => c.bh_workitem === workItemId)
      .sort((a, b) => new Date(a.createdon).getTime() - new Date(b.createdon).getTime());
  },
  createComment: async (data: any) => {
    await delay(200);
    const comment = {
      bh_commentid: generateId(),
      bh_content: data.bh_content,
      bh_workitem: data.bh_workitem,
      bh_author: data.bh_author || 'member-1', // Default to demo user
      createdon: new Date().toISOString(),
    };
    comments.push(comment);
    return comment;
  },
  updateComment: async (id: string, data: any) => {
    await delay(200);
    const idx = comments.findIndex(c => c.bh_commentid === id);
    if (idx !== -1) {
      comments[idx] = { ...comments[idx], ...data };
      return comments[idx];
    }
    throw new Error('Comment not found');
  },
  deleteComment: async (id: string) => {
    await delay(200);
    comments = comments.filter(c => c.bh_commentid !== id);
  },

  // File Attachments
  getFiles: async (workItemId: string) => {
    await delay(100);
    return attachments.filter(a => a.bh_workitem === workItemId);
  },
  uploadFile: async (file: File, workItemId: string) => {
    await delay(500); // Simulate upload time
    const attachment = {
      bh_attachmentid: generateId(),
      bh_filename: file.name,
      bh_filesize: file.size,
      bh_mimetype: file.type,
      bh_url: URL.createObjectURL(file), // Create a local blob URL for demo
      bh_workitem: workItemId,
      bh_uploadedby: 'member-1',
      createdon: new Date().toISOString(),
    };
    attachments.push(attachment);
    return attachment;
  },
  deleteFile: async (id: string) => {
    await delay(200);
    attachments = attachments.filter(a => a.bh_attachmentid !== id);
  },

  // Global Search
  search: async (query: string, projectId: string) => {
    await delay(150);
    const lowerQuery = query.toLowerCase();

    // Search work items
    const matchedWorkItems = workItems.filter(wi =>
      wi.bh_project === projectId && (
        wi.bh_name.toLowerCase().includes(lowerQuery) ||
        wi.bh_description?.toLowerCase().includes(lowerQuery) ||
        `#${wi.bh_sequenceid}`.includes(lowerQuery)
      )
    );

    // Search cycles
    const matchedCycles = cycles.filter(c =>
      c.bh_project === projectId && (
        c.bh_name.toLowerCase().includes(lowerQuery) ||
        c.bh_description?.toLowerCase().includes(lowerQuery)
      )
    );

    // Search modules
    const matchedModules = modules.filter(m =>
      m.bh_project === projectId && (
        m.bh_name.toLowerCase().includes(lowerQuery) ||
        m.bh_description?.toLowerCase().includes(lowerQuery)
      )
    );

    // Search pages
    const matchedPages = pages.filter(p =>
      p.bh_project === projectId && !p.bh_archived && (
        p.bh_name.toLowerCase().includes(lowerQuery) ||
        p.bh_content?.toLowerCase().includes(lowerQuery)
      )
    );

    // Search epics
    const matchedEpics = epics.filter(e =>
      e.bh_project === projectId && (
        e.bh_name.toLowerCase().includes(lowerQuery) ||
        e.bh_description?.toLowerCase().includes(lowerQuery)
      )
    );

    return {
      workItems: matchedWorkItems,
      cycles: matchedCycles,
      modules: matchedModules,
      pages: matchedPages,
      epics: matchedEpics,
    };
  },

  // Pages
  getPages: async (projectId: string) => {
    await delay(100);
    return pages.filter(p => p.bh_project === projectId && !p.bh_archived);
  },
  getPage: async (id: string) => {
    await delay(50);
    return pages.find(p => p.bh_pageid === id);
  },
  createPage: async (data: any) => {
    await delay(200);
    const page = {
      bh_pageid: generateId(),
      bh_name: data.bh_name,
      bh_content: data.bh_content || '',
      bh_icon: data.bh_icon || '📄',
      bh_parent: data.bh_parent || null,
      bh_project: data.bh_project,
      bh_createdby: data.bh_createdby || 'member-1',
      bh_archived: false,
      createdon: new Date().toISOString(),
      modifiedon: new Date().toISOString(),
    };
    pages.push(page);
    return page;
  },
  updatePage: async (id: string, data: any) => {
    await delay(200);
    const idx = pages.findIndex(p => p.bh_pageid === id);
    if (idx !== -1) {
      pages[idx] = { ...pages[idx], ...data, modifiedon: new Date().toISOString() };
      return pages[idx];
    }
    throw new Error('Page not found');
  },
  deletePage: async (id: string) => {
    await delay(200);
    // Archive instead of delete (soft delete)
    const idx = pages.findIndex(p => p.bh_pageid === id);
    if (idx !== -1) {
      pages[idx].bh_archived = true;
    }
  },

  // Views
  getViews: async (projectId: string) => {
    await delay(100);
    return views.filter(v => v.bh_project === projectId);
  },
  getView: async (id: string) => {
    await delay(50);
    return views.find(v => v.bh_viewid === id);
  },
  createView: async (data: any) => {
    await delay(200);
    const view = {
      bh_viewid: generateId(),
      bh_name: data.bh_name,
      bh_filters: data.bh_filters || {},
      bh_display: data.bh_display || { groupBy: 'state', sortBy: 'created' },
      bh_project: data.bh_project,
      bh_createdby: data.bh_createdby || 'member-1',
      createdon: new Date().toISOString(),
    };
    views.push(view);
    return view;
  },
  updateView: async (id: string, data: any) => {
    await delay(200);
    const idx = views.findIndex(v => v.bh_viewid === id);
    if (idx !== -1) {
      views[idx] = { ...views[idx], ...data };
      return views[idx];
    }
    throw new Error('View not found');
  },
  deleteView: async (id: string) => {
    await delay(200);
    views = views.filter(v => v.bh_viewid !== id);
  },

  // Activities
  getActivities: async (workItemId: string) => {
    await delay(100);
    return activities
      .filter(a => a.bh_workitem === workItemId)
      .sort((a, b) => new Date(b.createdon).getTime() - new Date(a.createdon).getTime());
  },
  createActivity: async (data: any) => {
    await delay(100);
    const activity = {
      bh_activityid: generateId(),
      bh_action: data.bh_action,
      bh_field: data.bh_field || null,
      bh_oldvalue: data.bh_oldvalue || null,
      bh_newvalue: data.bh_newvalue || null,
      bh_workitem: data.bh_workitem,
      bh_actor: data.bh_actor || 'member-1',
      createdon: new Date().toISOString(),
    };
    activities.push(activity);
    return activity;
  },

  // Notifications
  getNotifications: async (userId: string = 'member-1') => {
    await delay(100);
    return notifications
      .filter(n => n.bh_recipient === userId)
      .sort((a, b) => new Date(b.createdon).getTime() - new Date(a.createdon).getTime());
  },
  markNotificationRead: async (id: string) => {
    await delay(100);
    const idx = notifications.findIndex(n => n.bh_notificationid === id);
    if (idx !== -1) {
      notifications[idx].bh_read = true;
    }
  },
  markAllNotificationsRead: async (userId: string = 'member-1') => {
    await delay(100);
    notifications = notifications.map(n =>
      n.bh_recipient === userId ? { ...n, bh_read: true } : n
    );
  },

  // Epics
  getEpics: async (projectId: string) => {
    await delay(100);
    return epics.filter(e => e.bh_project === projectId);
  },
  getEpic: async (id: string) => {
    await delay(50);
    return epics.find(e => e.bh_epicid === id);
  },
  createEpic: async (data: any) => {
    await delay(200);
    const epic = {
      bh_epicid: generateId(),
      bh_name: data.bh_name,
      bh_description: data.bh_description || '',
      bh_color: data.bh_color || '#8B5CF6',
      bh_status: data.bh_status || 'planned',
      bh_project: data.bh_project,
      bh_lead: data.bh_lead || null,
      bh_startdate: data.bh_startdate || null,
      bh_targetdate: data.bh_targetdate || null,
      createdon: new Date().toISOString(),
    };
    epics.push(epic);
    return epic;
  },
  updateEpic: async (id: string, data: any) => {
    await delay(200);
    const idx = epics.findIndex(e => e.bh_epicid === id);
    if (idx !== -1) {
      epics[idx] = { ...epics[idx], ...data };
      return epics[idx];
    }
    throw new Error('Epic not found');
  },
  deleteEpic: async (id: string) => {
    await delay(200);
    // Remove epic reference from work items
    workItems = workItems.map(wi =>
      wi.bh_epic === id ? { ...wi, bh_epic: null } : wi
    ) as typeof workItems;
    epics = epics.filter(e => e.bh_epicid !== id);
  },

  // Sub-issues
  getSubIssues: async (parentId: string) => {
    await delay(100);
    return workItems.filter(wi => wi.bh_parent === parentId);
  },

  // Bulk operations
  bulkUpdateWorkItems: async (ids: string[], data: any) => {
    await delay(300);
    ids.forEach(id => {
      const idx = workItems.findIndex(wi => wi.bh_workitemid === id);
      if (idx !== -1) {
        workItems[idx] = {
          ...workItems[idx],
          ...data,
          _bh_state_value: data.bh_state || workItems[idx]._bh_state_value,
        };
      }
    });
    return workItems.filter(wi => ids.includes(wi.bh_workitemid));
  },
  bulkDeleteWorkItems: async (ids: string[]) => {
    await delay(300);
    workItems = workItems.filter(wi => !ids.includes(wi.bh_workitemid));
  },

  // Relations
  getRelations: async (issueId: string) => {
    await delay(100);
    // Get relations where this issue is the source
    const issueRelations = relations.filter(r => r.bh_issue === issueId);
    // Also get inverse relations (where this issue is the target)
    const inverseRelations = relations
      .filter(r => r.bh_related_issue === issueId)
      .map(r => ({
        ...r,
        bh_relationid: `inv-${r.bh_relationid}`,
        bh_issue: r.bh_related_issue,
        bh_related_issue: r.bh_issue,
        bh_relation_type: getInverseRelationType(r.bh_relation_type),
      }));
    return [...issueRelations, ...inverseRelations];
  },
  createRelation: async (data: any) => {
    await delay(200);
    // Check for existing relation
    const existing = relations.find(
      r => (r.bh_issue === data.bh_issue && r.bh_related_issue === data.bh_related_issue) ||
           (r.bh_issue === data.bh_related_issue && r.bh_related_issue === data.bh_issue)
    );
    if (existing) {
      throw new Error('Relation already exists');
    }
    const relation = {
      bh_relationid: generateId(),
      bh_issue: data.bh_issue,
      bh_related_issue: data.bh_related_issue,
      bh_relation_type: data.bh_relation_type,
      bh_project: data.bh_project,
    };
    relations.push(relation);
    return relation;
  },
  deleteRelation: async (relationId: string) => {
    await delay(200);
    // Handle inverse relation IDs
    const actualId = relationId.startsWith('inv-') ? relationId.slice(4) : relationId;
    relations = relations.filter(r => r.bh_relationid !== actualId);
  },
};

// Helper function to simulate network delay
function delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

// Helper to get inverse relation type
function getInverseRelationType(type: string): string {
  switch (type) {
    case 'blocking': return 'blocked_by';
    case 'blocked_by': return 'blocking';
    case 'relates_to': return 'relates_to';
    case 'duplicate_of': return 'duplicate_of';
    default: return type;
  }
}
